<template>
	<div class="page__content">
		<section class="section program">
			<timeline-component :initialDate="date"></timeline-component>
			<footer class="program__footer">
				<div class="program__footer__container">
					<div class="timeline__legend">
						<span><span class="icon icon--chrono"></span> {{t('timeline.legend.soon')}} </span>
						<span><span class="icon icon--loop"></span> {{t('timeline.legend.running')}}</span>
						<span><span class="icon icon--flag"></span>{{t('timeline.legend.finish')}} </span>
						<span><span class="icon icon--close"></span> {{t('timeline.legend.close')}}</span>
						<span>{{t('timeline.legend.info')}}</span>
					</div>
				</div>
			</footer>
		</section>
		<aside-prefooter :prefooter="false"></aside-prefooter>
	</div>

</template>
<script>
	import Vuex from 'vuex';
	import Timeline from './timeline/Timeline';
	import AsidePrefooter from '@/components/layout/AsidePrefooter';

	export default {
		name: 'TimelinePage',
		components: {
			'timeline-component': Timeline,
			AsidePrefooter
		},
		data() {
			return {}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			date() {
				return this.$route.params['date']
			}
		},
		mounted() {

		}
	}
</script>
<style lang="scss">

</style>